import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./Admin/admin.css";
import Button from 'react-bootstrap/Button';
import MoneyMgmtStudentTestCard from './money_mgmt_student_test_card';

class MoneyMgmtStudentTestModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        newFilter: false,
      }    
      this.newTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
}
 
sortStudentTestReport(){
    this.sortParm = document.getElementById("sortParm").value;
    switch (this.sortParm){
        case "default":
          this.newTestData.sort((a, b) => (a.user + a.dateAdded > b.user + a.dateAdded) ? 1 : -1)
          break;
        case "nbrGameMonths":
          this.newTestData.sort((a, b) => (+a.gameNbrMonths < +b.gameNbrMonths) ? 1 : -1)
          break;
        case "nbrCorrect":
          this.newTestData.sort((a, b) => (+a.nbrCorrect < +b.nbrCorrect) ? 1 : -1)
          break;
        default:
          break;
    }
    this.setState({waitState: false});
}

filterTestReport(filterValue){
    this.newTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
    if (filterValue === "all"){
       //  no filter applied
    }else{
        this.newTestData = this.newTestData.filter(elem => elem.testType === filterValue);
    }
    this.setState({newFilter: !this.state.newFilter});
}
   
render() {
    let accountNbr = "";
    if (this.props.accountNbr){
        accountNbr = this.props.accountNbr;
    }
    let accountName = "";
    if (this.props.accountName){
       accountName = this.props.accountName;
    }
    this.studentTestResults = this.newTestData.map((testInfo, index) =>
      <MoneyMgmtStudentTestCard testInfo={testInfo}  key={index} 
        />
          );
              
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="xl" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title className="w-100 text-center pe-4">Financial Literacy Test - Player Results For&nbsp;
                {this.studentTestResults.length} Tests
                {accountNbr ?
                  <div><b>Selected Account: </b>{accountNbr} - {accountName}</div>
                :
                  null
              }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              <span>
                <div className="d-flex align-items-center justify-content-between backgroundTopBottom"
                style={{ width: "100%" }} >
                <div className="d-flex align-items-center ml-5">
                  <label className="font-weight-bold mr-2"  htmlFor="sortParm" style={{ whiteSpace: "nowrap" }}>
                    Sort by:
                  </label>
                  <select className="filter-select small-select dropdown-toggle"
                    id="sortParm"  onChange={() => this.sortStudentTestReport()} >
                    <option value="default">Player Name and Test Date (default)</option>
                    <option value="nbrGameMonths">Number Game Months (descending)</option>
                    <option value="nbrCorrect">Number Correct (descending)</option>
                  </select>
                </div>

                <div className="d-flex align-items-center mr-5">
                  <label className="font-weight-bold mr-2" htmlFor="testType"
                    style={{ whiteSpace: "nowrap" }}>
                    Filter By Test Type:
                  </label>
                  <select className="filter-select small-select" id="testType"
                    onChange={(val) => this.filterTestReport(val.target.value)} >
                    <option value="all">no filter applied</option>
                    <option value="pre-test">pre-test</option>
                    <option value="mid-test">mid-test</option>
                    <option value="post-test">post-test</option>
                  </select>
                </div>
              </div>
              <table className="table m-0">
                <tbody>
                  <tr className="header-sticky">
                    <th>Test Date</th>
                    <th>Player Name</th>
                    <th>Test Type</th>
                    <th>Number of Games</th>
                    <th>Nbr Game Months</th>
                    <th>Number Correct</th>
                    <th>Percent Correct</th>
                  </tr>
                  {this.studentTestResults}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default MoneyMgmtStudentTestModal;